import HomeOverview from '@homeOverview/HomeOverview';
import type { NextPage } from 'next';
import BGImage from 'src/components/common/BGImage';
import Meta from 'src/components/common/Meta';
import SinglePageContainer from 'src/components/globals/SinglePageContainer';
import useResponsive from 'src/hooks/contexts/useResponsive';
import Main from 'src/styles/layouts/Main';
import { ESize } from 'src/styles/theme/utils/enums';
import { metaDescriptions } from 'src/texts/seo';
import { IHomePage } from './HomePage.type';

const HomePage: NextPage<IHomePage> = ({ overview }) => {
	const { isSmallerThanMd } = useResponsive();

	return (
		<>
			<Meta title='NG - Home' description={metaDescriptions.homepage} />

			<Main
				paddingTop={ESize['3xl']}
				mdPaddingTop={ESize['3xl']}
				smPaddingTop={52}
				mdPaddingX={ESize.xl}
				smPaddingX={ESize.unset}
				singlePage
			>
				{!isSmallerThanMd ? (
					<BGImage src='/assets/textures/background-1.webp' />
				) : (
					<BGImage src='/assets/textures/mobile-background.webp' />
				)}

				<SinglePageContainer>
					<HomeOverview data={overview} />
				</SinglePageContainer>
			</Main>
		</>
	);
};

export { HomePage };
